var poll_default = {
  "fontElementMap": "e-TTk",
  "container": "Ia9Br",
  "fullscreen": "cXNf6",
  "background_overlay": "vM5kJ",
  "with_image": "Elvge",
  "options": "_7gryp",
  "webview": "_3ZyrM",
  "grid": "iOaL4",
  "option": "ISUfL",
  "cta_button": "l2c7C",
  "add_option": "WFCAh",
  "see_more": "EA4Am",
  "list": "ipKsZ",
  "column": "mDT5p",
  "additional_note": "BRwgH",
  "spinner": "lsN8o",
  "spin": "oz7FT",
  "shown": "LMpEi",
  "error": "mfKUa"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
